const countryList = [
    {
        "country": "Afghanistan",
        "region": "Asia",
        "code": "AF"
    },
    {
        "country": "Albania",
        "region": "Europe",
        "code": "AL"
    },
    {
        "country": "Algeria",
        "region": "Africa",
        "code": "DZ"
    },
    {
        "country": "American Samoa",
        "region": "Oceania",
        "code": "AS"
    },
    {
        "country": "Andorra",
        "region": "Europe",
        "code": "AD"
    },
    {
        "country": "Angola",
        "region": "Africa",
        "code": "AO"
    },
    {
        "country": "Anguilla",
        "region": "The Caribbean",
        "code": "AI"
    },
    {
        "country": "Antarctica",
        "region": "Antarctic",
        "code": "AQ"
    },
    {
        "country": "Antigua and Barbuda",
        "region": "The Caribbean",
        "code": "AG"
    },
    {
        "country": "Argentina",
        "region": "South America",
        "code": "AR"
    },
    {
        "country": "Armenia",
        "region": "Asia",
        "code": "AM"
    },
    {
        "country": "Aruba",
        "region": "The Caribbean",
        "code": "AW"
    },
    {
        "country": "Australia",
        "region": "Oceania",
        "code": "AU"
    },
    {
        "country": "Austria",
        "region": "Europe",
        "code": "AT"
    },
    {
        "country": "Azerbaijan",
        "region": "Asia",
        "code": "AZ"
    },
    {
        "country": "Bahamas (the)",
        "region": "The Caribbean",
        "code": "BS"
    },
    {
        "country": "Bahrain",
        "region": "Middle East",
        "code": "BH"
    },
    {
        "country": "Bangladesh",
        "region": "Asia",
        "code": "BD"
    },
    {
        "country": "Barbados",
        "region": "The Caribbean",
        "code": "BB"
    },
    {
        "country": "Belarus",
        "region": "Europe",
        "code": "BY"
    },
    {
        "country": "Belgium",
        "region": "Europe",
        "code": "BE"
    },
    {
        "country": "Belize",
        "region": "Central America",
        "code": "BZ"
    },
    {
        "country": "Benin",
        "region": "Africa",
        "code": "BJ"
    },
    {
        "country": "Bermuda",
        "region": "North America",
        "code": "BM"
    },
    {
        "country": "Bhutan",
        "region": "Asia",
        "code": "BT"
    },
    {
        "country": "Bolivia (Plurinational State of)",
        "region": "South America",
        "code": "BO"
    },
    {
        "country": "Bonaire, Sint Eustatius and Saba",
        "region": "The Caribbean",
        "code": "BQ"
    },
    {
        "country": "Bosnia and Herzegovina",
        "region": "Europe",
        "code": "BA"
    },
    {
        "country": "Botswana",
        "region": "Africa",
        "code": "BW"
    },
    {
        "country": "Bouvet Island",
        "region": "Antarctic",
        "code": "BV"
    },
    {
        "country": "Brazil",
        "region": "South America",
        "code": "BR"
    },
    {
        "country": "British Indian Ocean Territory (the)",
        "region": "Asia",
        "code": "IO"
    },
    {
        "country": "Brunei Darussalam",
        "region": "Asia",
        "code": "BN"
    },
    {
        "country": "Bulgaria",
        "region": "Europe",
        "code": "BG"
    },
    {
        "country": "Burkina Faso",
        "region": "Africa",
        "code": "BF"
    },
    {
        "country": "Burundi",
        "region": "Africa",
        "code": "BI"
    },
    {
        "country": "Cabo Verde",
        "region": "Africa",
        "code": "CV"
    },
    {
        "country": "Cambodia",
        "region": "Asia",
        "code": "KH"
    },
    {
        "country": "Cameroon",
        "region": "Africa",
        "code": "CM"
    },
    {
        "country": "Canada",
        "region": "North America",
        "code": "CA"
    },
    {
        "country": "Cayman Islands (the)",
        "region": "The Caribbean",
        "code": "KY"
    },
    {
        "country": "Central African Republic (the)",
        "region": "Africa",
        "code": "CF"
    },
    {
        "country": "Chad",
        "region": "Africa",
        "code": "TD"
    },
    {
        "country": "Chile",
        "region": "South America",
        "code": "CL"
    },
    {
        "country": "China",
        "region": "Asia",
        "code": "CN"
    },
    {
        "country": "Christmas Island",
        "region": "Oceania",
        "code": "CX"
    },
    {
        "country": "Cocos (Keeling) Islands (the)",
        "region": "Oceania",
        "code": "CC"
    },
    {
        "country": "Colombia",
        "region": "South America",
        "code": "CO"
    },
    {
        "country": "Comoros (the)",
        "region": "Africa",
        "code": "KM"
    },
    {
        "country": "Congo (the Democratic Republic of the)",
        "region": "Africa",
        "code": "CD"
    },
    {
        "country": "Congo (the)",
        "region": "Africa",
        "code": "CG"
    },
    {
        "country": "Cook Islands (the)",
        "region": "Oceania",
        "code": "CK"
    },
    {
        "country": "Costa Rica",
        "region": "Central America",
        "code": "CR"
    },
    {
        "country": "Croatia",
        "region": "Europe",
        "code": "HR"
    },
    {
        "country": "Cuba",
        "region": "The Caribbean",
        "code": "CU"
    },
    {
        "country": "Curaçao",
        "region": "The Caribbean",
        "code": "CW"
    },
    {
        "country": "Cyprus",
        "region": "Europe",
        "code": "CY"
    },
    {
        "country": "Czechia",
        "region": "Europe",
        "code": "CZ"
    },
    {
        "country": "Côte d'Ivoire",
        "region": "Africa",
        "code": "CI"
    },
    {
        "country": "Denmark",
        "region": "Europe",
        "code": "DK"
    },
    {
        "country": "Djibouti",
        "region": "Africa",
        "code": "DJ"
    },
    {
        "country": "Dominica",
        "region": "The Caribbean",
        "code": "DM"
    },
    {
        "country": "Dominican Republic (the)",
        "region": "The Caribbean",
        "code": "DO"
    },
    {
        "country": "Ecuador",
        "region": "South America",
        "code": "EC"
    },
    {
        "country": "Egypt",
        "region": "Africa",
        "code": "EG"
    },
    {
        "country": "El Salvador",
        "region": "Central America",
        "code": "SV"
    },
    {
        "country": "Equatorial Guinea",
        "region": "Africa",
        "code": "GQ"
    },
    {
        "country": "Eritrea",
        "region": "Africa",
        "code": "ER"
    },
    {
        "country": "Estonia",
        "region": "Europe",
        "code": "EE"
    },
    {
        "country": "Eswatini",
        "region": "Africa",
        "code": "SZ"
    },
    {
        "country": "Ethiopia",
        "region": "Africa",
        "code": "ET"
    },
    {
        "country": "Falkland Islands (the) [Malvinas]",
        "region": "South America",
        "code": "FK"
    },
    {
        "country": "Faroe Islands (the)",
        "region": "Europe",
        "code": "FO"
    },
    {
        "country": "Fiji",
        "region": "Oceania",
        "code": "FJ"
    },
    {
        "country": "Finland",
        "region": "Europe",
        "code": "FI"
    },
    {
        "country": "France",
        "region": "Europe",
        "code": "FR"
    },
    {
        "country": "French Guiana",
        "region": "South America",
        "code": "GF"
    },
    {
        "country": "French Polynesia",
        "region": "Oceania",
        "code": "PF"
    },
    {
        "country": "French Southern Territories (the)",
        "region": "Antarctic",
        "code": "TF"
    },
    {
        "country": "Gabon",
        "region": "Africa",
        "code": "GA"
    },
    {
        "country": "Gambia (the)",
        "region": "Africa",
        "code": "GM"
    },
    {
        "country": "Georgia",
        "region": "Asia",
        "code": "GE"
    },
    {
        "country": "Germany",
        "region": "Europe",
        "code": "DE"
    },
    {
        "country": "Ghana",
        "region": "Africa",
        "code": "GH"
    },
    {
        "country": "Gibraltar",
        "region": "Europe",
        "code": "GI"
    },
    {
        "country": "Greece",
        "region": "Europe",
        "code": "GR"
    },
    {
        "country": "Greenland",
        "region": "North America",
        "code": "GL"
    },
    {
        "country": "Grenada",
        "region": "The Caribbean",
        "code": "GD"
    },
    {
        "country": "Guadeloupe",
        "region": "The Caribbean",
        "code": "GP"
    },
    {
        "country": "Guam",
        "region": "Oceania",
        "code": "GU"
    },
    {
        "country": "Guatemala",
        "region": "Central America",
        "code": "GT"
    },
    {
        "country": "Guernsey",
        "region": "Europe",
        "code": "GG"
    },
    {
        "country": "Guinea",
        "region": "Africa",
        "code": "GN"
    },
    {
        "country": "Guinea-Bissau",
        "region": "Africa",
        "code": "GW"
    },
    {
        "country": "Guyana",
        "region": "South America",
        "code": "GY"
    },
    {
        "country": "Haiti",
        "region": "The Caribbean",
        "code": "HT"
    },
    {
        "country": "Heard Island and McDonald Islands",
        "region": "Antarctic",
        "code": "HM"
    },
    {
        "country": "Holy See (the)",
        "region": "Europe",
        "code": "VA"
    },
    {
        "country": "Honduras",
        "region": "Central America",
        "code": "HN"
    },
    {
        "country": "Hong Kong",
        "region": "Asia",
        "code": "HK"
    },
    {
        "country": "Hungary",
        "region": "Europe",
        "code": "HU"
    },
    {
        "country": "Iceland",
        "region": "Europe",
        "code": "IS"
    },
    {
        "country": "India",
        "region": "Asia",
        "code": "IN"
    },
    {
        "country": "Indonesia",
        "region": "Asia",
        "code": "ID"
    },
    {
        "country": "Iran (Islamic Republic of)",
        "region": "Middle East",
        "code": "IR"
    },
    {
        "country": "Iraq",
        "region": "Middle East",
        "code": "IQ"
    },
    {
        "country": "Ireland",
        "region": "Europe",
        "code": "IE"
    },
    {
        "country": "Isle of Man",
        "region": "Europe",
        "code": "IM"
    },
    {
        "country": "Israel",
        "region": "Middle East",
        "code": "IL"
    },
    {
        "country": "Italy",
        "region": "Europe",
        "code": "IT"
    },
    {
        "country": "Jamaica",
        "region": "The Caribbean",
        "code": "JM"
    },
    {
        "country": "Japan",
        "region": "Asia",
        "code": "JP"
    },
    {
        "country": "Jersey",
        "region": "Europe",
        "code": "JE"
    },
    {
        "country": "Jordan",
        "region": "Middle East",
        "code": "JO"
    },
    {
        "country": "Kazakhstan",
        "region": "Asia",
        "code": "KZ"
    },
    {
        "country": "Kenya",
        "region": "Africa",
        "code": "KE"
    },
    {
        "country": "Kiribati",
        "region": "Oceania",
        "code": "KI"
    },
    {
        "country": "Korea (the Democratic People's Republic of)",
        "region": "Asia",
        "code": "KP"
    },
    {
        "country": "Korea (the Republic of)",
        "region": "Asia",
        "code": "KR"
    },
    {
        "country": "Kuwait",
        "region": "Middle East",
        "code": "KW"
    },
    {
        "country": "Kyrgyzstan",
        "region": "Asia",
        "code": "KG"
    },
    {
        "country": "Lao People's Democratic Republic (the)",
        "region": "Asia",
        "code": "LA"
    },
    {
        "country": "Latvia",
        "region": "Europe",
        "code": "LV"
    },
    {
        "country": "Lebanon",
        "region": "Middle East",
        "code": "LB"
    },
    {
        "country": "Lesotho",
        "region": "Africa",
        "code": "LS"
    },
    {
        "country": "Liberia",
        "region": "Africa",
        "code": "LR"
    },
    {
        "country": "Libya",
        "region": "Africa",
        "code": "LY"
    },
    {
        "country": "Liechtenstein",
        "region": "Europe",
        "code": "LI"
    },
    {
        "country": "Lithuania",
        "region": "Europe",
        "code": "LT"
    },
    {
        "country": "Luxembourg",
        "region": "Europe",
        "code": "LU"
    },
    {
        "country": "Macao",
        "region": "Asia",
        "code": "MO"
    },
    {
        "country": "Madagascar",
        "region": "Africa",
        "code": "MG"
    },
    {
        "country": "Malawi",
        "region": "Africa",
        "code": "MW"
    },
    {
        "country": "Malaysia",
        "region": "Asia",
        "code": "MY"
    },
    {
        "country": "Maldives",
        "region": "Asia",
        "code": "MV"
    },
    {
        "country": "Mali",
        "region": "Africa",
        "code": "ML"
    },
    {
        "country": "Malta",
        "region": "Europe",
        "code": "MT"
    },
    {
        "country": "Marshall Islands (the)",
        "region": "Oceania",
        "code": "MH"
    },
    {
        "country": "Martinique",
        "region": "The Caribbean",
        "code": "MQ"
    },
    {
        "country": "Mauritania",
        "region": "Africa",
        "code": "MR"
    },
    {
        "country": "Mauritius",
        "region": "Africa",
        "code": "MU"
    },
    {
        "country": "Mayotte",
        "region": "Africa",
        "code": "YT"
    },
    {
        "country": "Mexico",
        "region": "Central America",
        "code": "MX"
    },
    {
        "country": "Micronesia (Federated States of)",
        "region": "Oceania",
        "code": "FM"
    },
    {
        "country": "Moldova (the Republic of)",
        "region": "Europe",
        "code": "MD"
    },
    {
        "country": "Monaco",
        "region": "Europe",
        "code": "MC"
    },
    {
        "country": "Mongolia",
        "region": "Asia",
        "code": "MN"
    },
    {
        "country": "Montenegro",
        "region": "Europe",
        "code": "ME"
    },
    {
        "country": "Montserrat",
        "region": "The Caribbean",
        "code": "MS"
    },
    {
        "country": "Morocco",
        "region": "Africa",
        "code": "MA"
    },
    {
        "country": "Mozambique",
        "region": "Africa",
        "code": "MZ"
    },
    {
        "country": "Myanmar",
        "region": "Asia",
        "code": "MM"
    },
    {
        "country": "Namibia",
        "region": "Africa",
        "code": "NA"
    },
    {
        "country": "Nauru",
        "region": "Oceania",
        "code": "NR"
    },
    {
        "country": "Nepal",
        "region": "Asia",
        "code": "NP"
    },
    {
        "country": "Netherlands (the)",
        "region": "Europe",
        "code": "NL"
    },
    {
        "country": "New Caledonia",
        "region": "Oceania",
        "code": "NC"
    },
    {
        "country": "New Zealand",
        "region": "Oceania",
        "code": "NZ"
    },
    {
        "country": "Nicaragua",
        "region": "Central America",
        "code": "NI"
    },
    {
        "country": "Niger (the)",
        "region": "Africa",
        "code": "NE"
    },
    {
        "country": "Nigeria",
        "region": "Africa",
        "code": "NG"
    },
    {
        "country": "Niue",
        "region": "Oceania",
        "code": "NU"
    },
    {
        "country": "Norfolk Island",
        "region": "Oceania",
        "code": "NF"
    },
    {
        "country": "North Macedonia",
        "region": "Europe",
        "code": "MK"
    },
    {
        "country": "Northern Mariana Islands (the)",
        "region": "Oceania",
        "code": "MP"
    },
    {
        "country": "Norway",
        "region": "Europe",
        "code": "NO"
    },
    {
        "country": "Oman",
        "region": "Middle East",
        "code": "OM"
    },
    {
        "country": "Pakistan",
        "region": "Asia",
        "code": "PK"
    },
    {
        "country": "Palau",
        "region": "Oceania",
        "code": "PW"
    },
    {
        "country": "Palestine, State of",
        "region": "Middle East",
        "code": "PS"
    },
    {
        "country": "Panama",
        "region": "Central America",
        "code": "PA"
    },
    {
        "country": "Papua New Guinea",
        "region": "Oceania",
        "code": "PG"
    },
    {
        "country": "Paraguay",
        "region": "South America",
        "code": "PY"
    },
    {
        "country": "Peru",
        "region": "South America",
        "code": "PE"
    },
    {
        "country": "Philippines (the)",
        "region": "Asia",
        "code": "PH"
    },
    {
        "country": "Pitcairn",
        "region": "Oceania",
        "code": "PN"
    },
    {
        "country": "Poland",
        "region": "Europe",
        "code": "PL"
    },
    {
        "country": "Portugal",
        "region": "Europe",
        "code": "PT"
    },
    {
        "country": "Puerto Rico",
        "region": "The Caribbean",
        "code": "PR"
    },
    {
        "country": "Qatar",
        "region": "Middle East",
        "code": "QA"
    },
    {
        "country": "Romania",
        "region": "Europe",
        "code": "RO"
    },
    {
        "country": "Russian Federation (the)",
        "region": "Europe",
        "code": "RU"
    },
    {
        "country": "Rwanda",
        "region": "Africa",
        "code": "RW"
    },
    {
        "country": "Réunion",
        "region": "Africa",
        "code": "RE"
    },
    {
        "country": "Saint Barthélemy",
        "region": "The Caribbean",
        "code": "BL"
    },
    {
        "country": "Saint Helena, Ascension and Tristan da Cunha",
        "region": "Africa",
        "code": "SH"
    },
    {
        "country": "Saint Kitts and Nevis",
        "region": "The Caribbean",
        "code": "KN"
    },
    {
        "country": "Saint Lucia",
        "region": "The Caribbean",
        "code": "LC"
    },
    {
        "country": "Saint Martin (French part)",
        "region": "The Caribbean",
        "code": "MF"
    },
    {
        "country": "Saint Pierre and Miquelon",
        "region": "North America",
        "code": "PM"
    },
    {
        "country": "Saint Vincent and the Grenadines",
        "region": "The Caribbean",
        "code": "VC"
    },
    {
        "country": "Samoa",
        "region": "Oceania",
        "code": "WS"
    },
    {
        "country": "San Marino",
        "region": "Europe",
        "code": "SM"
    },
    {
        "country": "Sao Tome and Principe",
        "region": "Africa",
        "code": "ST"
    },
    {
        "country": "Saudi Arabia",
        "region": "Middle East",
        "code": "SA"
    },
    {
        "country": "Senegal",
        "region": "Africa",
        "code": "SN"
    },
    {
        "country": "Serbia",
        "region": "Europe",
        "code": "RS"
    },
    {
        "country": "Seychelles",
        "region": "Africa",
        "code": "SC"
    },
    {
        "country": "Sierra Leone",
        "region": "Africa",
        "code": "SL"
    },
    {
        "country": "Singapore",
        "region": "Asia",
        "code": "SG"
    },
    {
        "country": "Sint Maarten (Dutch part)",
        "region": "The Caribbean",
        "code": "SX"
    },
    {
        "country": "Slovakia",
        "region": "Europe",
        "code": "SK"
    },
    {
        "country": "Slovenia",
        "region": "Europe",
        "code": "SI"
    },
    {
        "country": "Solomon Islands",
        "region": "Oceania",
        "code": "SB"
    },
    {
        "country": "Somalia",
        "region": "Africa",
        "code": "SO"
    },
    {
        "country": "South Africa",
        "region": "Africa",
        "code": "ZA"
    },
    {
        "country": "South Georgia and the South Sandwich Islands",
        "region": "Antarctic",
        "code": "GS"
    },
    {
        "country": "South Sudan",
        "region": "Africa",
        "code": "SS"
    },
    {
        "country": "Spain",
        "region": "Europe",
        "code": "ES"
    },
    {
        "country": "Sri Lanka",
        "region": "Asia",
        "code": "LK"
    },
    {
        "country": "Sudan (the)",
        "region": "Africa",
        "code": "SD"
    },
    {
        "country": "Suriname",
        "region": "South America",
        "code": "SR"
    },
    {
        "country": "Svalbard and Jan Mayen",
        "region": "Europe",
        "code": "SJ"
    },
    {
        "country": "Sweden",
        "region": "Europe",
        "code": "SE"
    },
    {
        "country": "Switzerland",
        "region": "Europe",
        "code": "CH"
    },
    {
        "country": "Syrian Arab Republic (the)",
        "region": "Middle East",
        "code": "SY"
    },
    {
        "country": "Taiwan (Province of China)",
        "region": "Asia",
        "code": "TW"
    },
    {
        "country": "Tajikistan",
        "region": "Asia",
        "code": "TJ"
    },
    {
        "country": "Tanzania, the United Republic of",
        "region": "Africa",
        "code": "TZ"
    },
    {
        "country": "Thailand",
        "region": "Asia",
        "code": "TH"
    },
    {
        "country": "Timor-Leste",
        "region": "Asia",
        "code": "TL"
    },
    {
        "country": "Togo",
        "region": "Africa",
        "code": "TG"
    },
    {
        "country": "Tokelau",
        "region": "Oceania",
        "code": "TK"
    },
    {
        "country": "Tonga",
        "region": "Oceania",
        "code": "TO"
    },
    {
        "country": "Trinidad and Tobago",
        "region": "The Caribbean",
        "code": "TT"
    },
    {
        "country": "Tunisia",
        "region": "Africa",
        "code": "TN"
    },
    {
        "country": "Turkey",
        "region": "Europe",
        "code": "TR"
    },
    {
        "country": "Turkmenistan",
        "region": "Asia",
        "code": "TM"
    },
    {
        "country": "Turks and Caicos Islands (the)",
        "region": "The Caribbean",
        "code": "TC"
    },
    {
        "country": "Tuvalu",
        "region": "Oceania",
        "code": "TV"
    },
    {
        "country": "Uganda",
        "region": "Africa",
        "code": "UG"
    },
    {
        "country": "Ukraine",
        "region": "Europe",
        "code": "UA"
    },
    {
        "country": "United Arab Emirates (the)",
        "region": "Middle East",
        "code": "AE"
    },
    {
        "country": "United Kingdom of Great Britain and Northern Ireland (the)",
        "region": "Europe",
        "code": "GB"
    },
    {
        "country": "United States Minor Outlying Islands (the)",
        "region": "Oceania",
        "code": "UM"
    },
    {
        "country": "United States of America (the)",
        "region": "North America",
        "code": "US"
    },
    {
        "country": "Uruguay",
        "region": "South America",
        "code": "UY"
    },
    {
        "country": "Uzbekistan",
        "region": "Asia",
        "code": "UZ"
    },
    {
        "country": "Vanuatu",
        "region": "Oceania",
        "code": "VU"
    },
    {
        "country": "Venezuela (Bolivarian Republic of)",
        "region": "South America",
        "code": "VE"
    },
    {
        "country": "Viet Nam",
        "region": "Asia",
        "code": "VN"
    },
    {
        "country": "Virgin Islands (British)",
        "region": "The Caribbean",
        "code": "VG"
    },
    {
        "country": "Virgin Islands (U.S.)",
        "region": "The Caribbean",
        "code": "VI"
    },
    {
        "country": "Wallis and Futuna",
        "region": "Oceania",
        "code": "WF"
    },
    {
        "country": "Western Sahara*",
        "region": "Africa",
        "code": "EH"
    },
    {
        "country": "Yemen",
        "region": "Middle East",
        "code": "YE"
    },
    {
        "country": "Zambia",
        "region": "Africa",
        "code": "ZM"
    },
    {
        "country": "Zimbabwe",
        "region": "Africa",
        "code": "ZW"
    },
    {
        "country": "Åland Islands",
        "region": "Europe",
        "code": "AX"
    }
]

export default countryList